import { render, staticRenderFns } from "./BeautyConfigurationSummary.vue?vue&type=template&id=c2c6076a&scoped=true"
import script from "./BeautyConfigurationSummary.vue?vue&type=script&lang=js"
export * from "./BeautyConfigurationSummary.vue?vue&type=script&lang=js"
import style0 from "./BeautyConfigurationSummary.vue?vue&type=style&index=0&id=c2c6076a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2c6076a",
  null
  
)

export default component.exports